import ListActions from "modules/list/actions";

import { CronJobSchema } from "utils/schemas";

export const CRONJOBS_MODULE = "clusterGroupCronJobs";

export const cronjobsListingActions = new ListActions({
  async fetchData({ namespaces = [], clusters = [] } = {}) {
    //TODO
    return {
      items: [],
    };
  },
  initialQuery: () => ({
    namespaces: [],
    clusters: [],
  }),
  schema: [CronJobSchema],
});
